// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".importing-tip[data-v-051cceb4] {\n  margin-left: 0.26667rem;\n  font-size: 0.32rem;\n  color: var(--el-color-warning, #e6a23c);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
